import React, { useState, useEffect } from 'react';
import { useAuth, API_URL, Currency } from '../contexts/AuthContext';
import { Plus, Truck, CreditCard, Search } from 'lucide-react';

export default function Compras() {
  const { token } = useAuth();
  const [purchases, setPurchases] = useState<any[]>([]);
  const [suppliers, setSuppliers] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ supplier_id: '', payment_method: 'money', items: [{ product_id: '', quantity: '', unit_cost: '' }] });
  const [msg, setMsg] = useState('');

  useEffect(() => {
    if (!token) return;
    fetch(`${API_URL}/purchases`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setPurchases(d)).catch(() => {});
    fetch(`${API_URL}/suppliers`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setSuppliers(d)).catch(() => {});
  }, [token]);

  const save = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const r = await fetch(`${API_URL}/purchases/`, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify(form) });
      if (!r.ok) { setMsg('Erro ao registrar compra'); return; }
      setMsg('Compra registrada'), setOpen(false);
      fetch(`${API_URL}/purchases`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setPurchases(d)).catch(() => {});
    } catch { setMsg('Erro interno'); }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Compras</h1>
          <p className="text-gray-600">Registro de compras de mercadorias</p>
        </div>
        <button onClick={() => setOpen(true)} className="btn-primary"><Plus size={18} /> Nova compra</button>
      </div>
      {msg && <div className="rounded-lg p-3 text-sm bg-green-50 border border-green-200 text-green-700">{msg}</div>}
      <div className="table-wrap">
        <table className="w-full text-left text-sm">
          <thead><tr className="border-b border-gray-200"><th className="pb-2 text-gray-500">Número</th><th className="pb-2 text-gray-500">Fornecedor</th><th className="pb-2 text-gray-500 text-right">Total</th><th className="pb-2 text-gray-500">Pagamento</th><th className="pb-2 text-gray-500">Situação</th></tr></thead>
          <tbody>
            {purchases.map(p => (
              <tr key={p.id} className="border-b border-gray-100 last:border-0">
                <td className="py-2 font-medium">{p.purchase_number}</td>
                <td className="py-2">{p.supplier_name}</td>
                <td className="py-2 text-right">{Currency(p.total)}</td>
                <td className="py-2 text-sm">{p.payment_method}</td>
                <td className="py-2"><span className={`badge ${p.status === 'paid' ? 'badge-ok' : 'badge-warn'}`}>{p.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl">
            <h2 className="text-lg font-bold text-gray-900 mb-4">Nova compra</h2>
            <form onSubmit={save} className="space-y-3">
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Fornecedor</label><select className="input" value={form.supplier_id} onChange={e => setForm({ ...form, supplier_id: e.target.value })} required><option value="">Selecione</option>{suppliers.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}</select></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Forma de pagamento</label><select className="input" value={form.payment_method} onChange={e => setForm({ ...form, payment_method: e.target.value })}><option value="money">Dinheiro</option><option value="pix">Pix</option><option value="card">Cartão</option><option value="credit">Fiado a fornecedor</option></select></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Itens (ID do produto · quantidade · custo unitário)</label>
                {form.items.map((it, i) => (
                  <div key={i} className="grid grid-cols-3 gap-2 mb-2">
                    <input className="input" value={it.product_id} onChange={e => { const it2 = [...form.items]; it2[i] = { ...it2, product_id: e.target.value }; setForm({ ...form, items: it2 }); }} placeholder="ID produto" />
                    <input className="input" type="number" step="0.001" value={it.quantity} onChange={e => { const it2 = [...form.items]; it2[i] = { ...it2, quantity: e.target.value }; setForm({ ...form, items: it2 }); }} placeholder="Qtd" />
                    <input className="input" type="number" step="0.01" value={it.unit_cost} onChange={e => { const it2 = [...form.items]; it2[i] = { ...it2, unit_cost: e.target.value }; setForm({ ...form, items: it2 }); }} placeholder="Custo" />
                  </div>
                ))}
                <button type="button" onClick={() => setForm({ ...form, items: [...form.items, { product_id: '', quantity: '', unit_cost: '' }] })} className="text-xs text-blue-600">+ Adicionar item</button>
              </div>
              <div className="flex justify-end gap-2 pt-4">
                <button type="button" onClick={() => setOpen(false)} className="btn-ghost px-4">Cancelar</button>
                <button className="btn-primary">Registrar compra</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
